import { TMaintenanceListItem } from 'core/model/interfaces/maintenance';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../constants';
import type { IMaintenanceState } from '../types';

export const fetchMaintenanceById = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/fetchMaintenanceById`,
  async (id: TMaintenanceListItem['id']) => {
    try {
      const response = await apiService.maintenance.getMaintenanceById(id);

      return response;
    } catch (error) {
      const errorMessage = handleErrorMessage(error, 'Falló al cargar el mantenimiento.');

      notificationService.global.error(errorMessage);

      throw error;
    }
  },
);

export const fetchMaintenanceByIdReducer: TSliceExtraReducer<IMaintenanceState> = builder =>
  builder
    .addCase(fetchMaintenanceById.pending, state => {
      state.maintenance.loading = true;
      state.maintenance.success = false;
      state.maintenance.maintenance = null;
    })
    .addCase(fetchMaintenanceById.rejected, state => {
      state.maintenance.loading = false;
      state.maintenance.success = false;
      state.maintenance.maintenance = null;
    })
    .addCase(fetchMaintenanceById.fulfilled, (state, action) => {
      state.maintenance.loading = false;
      state.maintenance.success = true;
      state.maintenance.maintenance = action.payload;
    });
